// @vue/component
import { subjectExportApi, exportSubjectIndoFn } from "@/api/subjects";

export default {
  name: "Daochu",

  components: {},

  mixins: [],

  props: {
    project: {
      type: Object,
      require: true
    },
    select_list: {
      type: Array,
      require: true
    }
  },

  data() {
    return {
      the_type: "",
      to: "",
      loading: false,
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },

  computed: {},

  watch: {},

  created() {},

  methods: {
    goExport() {
      //导出
      if (!this.the_type) {
        this.$message({
          message: "请选择文件类型",
          type: "warning"
        });
        return false;
      }
      if (!this.to) {
        this.$message({
          message: "请选择导出地址",
          type: "warning"
        });
        return false;
      }
      let id_list = this.select_list.map(item => {
        return item.id;
      });
      this.loading = true;
      if (this.to === "本地") {
        exportSubjectIndoFn({
          project_id: this.project.id,
          the_type: this.the_type,
          user_id:this.userDetail.id,
          to: this.to,
          stype: "正常",
          random: Math.random(),
          id_list
        })
          .then(res => {
            this.export_excel_file(res);
            this.$message({
              message: "下载成功",
              type: "success"
            });
            this.$emit("close");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        const params = {
          project_id: this.project.id,
          user_id:this.userDetail.id,
          the_type: this.the_type,
          to: this.to,
          stype: "正常",
          id_list
        };
        if (this.to === "邮箱") {
          subjectExportApi(params)
            .then(res => {
              if (res && res.errcode === 200) {
                this.$message({
                  message: res.errmsg,
                  type: "success"
                });
                this.$emit("close");
              } else {
                this.$message.error(res.errmsg);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          exportSubjectIndoFn(params)
            .then(res => {
              this.export_excel_file(res);
              this.$message({
                message: "下载成功",
                type: "success"
              });
              this.$emit("close");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    export_excel_file(export_data) {
      // console.log(this.$store.getters.file_type)
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([export_data], {
        type: this.$store.getters.file_type
      });
      let link = document.createElement("a");
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = this.$store.getters.file_name;
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
    }
  }
};
